/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    PlanActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchSubscriptionEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_FETCH && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, PlanActions.receiveSubscription))
);

export const fetchPlanDetailEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_FETCH_DETAIL && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.receivePlanDetail))
);

export const createSubscriptionEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.createdSubscription))
);

export const updateSubscriptionEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.updatedSubscription))
);

export const updateAddOnsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_ADDON_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.updatedAddOns))
);

export const fetchLimitCheckEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_LIMIT_CHECK && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.receiveLimitCheck))
);

export const fetchPlansEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_FETCH_PLANS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.receievePlans))
);

export const fetchInvoicesEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_FETCH_INVOICES && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.receiveInvoices))
);

export const fetchBillingInfoEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_FETCH_BILLING && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.receiveBillingInfo))
);

export const updateBillingInfoEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_UPDATE_BILLING && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.updatedBillingInfo))
);

export const updatePullFreqEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_UPDATE_PULL_FREQ && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.updatedPullFreq))
);

export const validateCouponEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_VALIDATE_COUPON && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.receiveValidateCoupon))
);

export const validatePromoEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_VALIDATE_PROMO && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.validatedPromo))
);

export const redeemPromoEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_REDEEM_PROMO && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.redeemedPromo))
);

export const pauseSubscripitonEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_PAUSE_SUBSCRIPTION && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.pausedSubscription))
);

export const applyCouponEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_APPLY_COUPON && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.appliedCoupon))
);

export const fetchExpiredPlanEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_FETCH_EXPIRED_PLAN && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.receiveExpiredPlan))
);

export const clearSnapshotEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUB_CLEAR_SNAPSHOT && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PlanActions.receiveClearSnapshot))
);
